import React from "react";
import Box, { Item } from 'devextreme-react/box';
import TileView from 'devextreme-react/tile-view';

export default function RecogResultCropFooter({ data, clickFunction }) {
    function CropImageSelect(e) {
        clickFunction(e.itemIndex, e.itemData.regNo);
    }

    return (
        <Box
            direction="col"
            width="100%"
            height="100%"
        >
            <Item ratio={1}>
                <Box
                    height="100%"
                    crossAlign="center"
                >
                    <Item ratio={1}>
                        <a>산출 이미지</a>
                    </Item>
                </Box>
            </Item>
            <Item ratio={5}>
                <Box
                    direction="row"
                    width="100%"
                    height="100%"
                    style={{
                        borderWidth: 1,
                        borderStyle: "solid",
                        borderColor: "#3cbab2"
                    }}
                >
                    <Item ratio={1}>
                        <TileView
                            items={data}
                            itemRender={ImageTileItem}
                            itemMargin={7}
                            baseItemHeight={124}
                            baseItemWidth={124}
                            showScrollbar="onHover"
                            activeStateEnabled={false}
                            onItemClick={CropImageSelect}
                        />
                    </Item>
                </Box>
            </Item>
        </Box>
    );
}

function ImageTileItem(item) {
    if (item.regNo == -1) {
        return (
            <Box
                height="100%"
                crossAlign="center"
                style={{
                    borderWidth: 1,
                    borderStyle: "solid"
                }}
            >
                <Item ratio={1}>
                    <a
                        align="center"
                        style={{
                            fontSize: "large"
                        }}
                    >원본보기</a>
                </Item>
            </Box>
        );
    }
    else {
        return (
            <img
                direction="col"
                width="100%"
                height="100%"
                src={item.orgImg}
                style={{
                    borderWidth: 1,
                    borderStyle: "solid",
                    pointerEvents: "none"
                }}
            />
        );
    }
}